import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { VehicleRequestEntity } from "./vehicle-req-entity";
import { VehiclereqController } from "./vehicle-req-controller";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { VehicleReqService } from "./vehicle-req-service";
import { VehicleReqRepo } from "./vehicle-req-repo";
import { WhatsAppNotificationService } from "packages/libs/shared-services/src/notification-management/whatsapp-notification-service";
import { VehicleEntity } from "../vehicle/vehicle.entity";
import { EmployeeRepo } from "../employee/employee.repo";
import { EmployeeEntity } from "../employee/employee.entity";
import { MailerService } from "./send-mail";
import { EmailService } from "@project-management-system/shared-services";

@Module({
imports:[
    TypeOrmModule.forFeature([VehicleRequestEntity,VehicleEntity,EmployeeEntity])
],
controllers:[VehiclereqController],
providers: [VehicleReqService, ApplicationExceptionHandler,VehicleReqRepo, WhatsAppNotificationService,EmployeeRepo,EmailService,MailerService]

})
export class VehiclereqModule{}
